export default "__VITE_ASSET__CxSSpxns__"